export const REALTIME_API_V1 = '1';